<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Policy</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form ref="form" class="modal-card-body" :valid.sync="valid">
          <div class="field">
            <label class="label">Policy Name*</label>
            <v-text-field 
              required
              placeholder="Enter Policy Name"
              v-model="policy.name">
            </v-text-field>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNewPolicy()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    permissions: {
      type: Object
    },
    createEmpty: {
      type: Boolean
    }
  },
  components: { VTextField, VForm },
  data() {
    return {
      policy: {
        name: '',
        permissions: {}
      },
      valid: false
    }
  },
  created() { },
  methods: {
    ...mapActions("permissions", ["addPolicy"]),
    addNewPolicy() {
      this.policy.permissions = (this.createEmpty) ? {} : this.permissions;

      this.addPolicy({ data: this.policy }).then(resp => {
        this.$emit('success', resp.data);
        this.$emit('finishCreate', resp.data.id);
        this.close(true);
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
